import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from '../utils/cn';
/** Trennlinie auf Basis der `.sec-divider`-Klasse (MUI-`Divider`-Ersatz). */
export const Divider = forwardRef(function Divider({ orientation = 'horizontal', className, ...rest }, ref) {
    return (_jsx("hr", { ref: ref, className: cn('sec-divider', orientation === 'vertical' && 'sec-divider--vertical', className), ...rest }));
});
